import React from 'react';
import { addPanelRequest } from 'services/apiSrv';
import { useQuery } from 'react-query';
import { Modal } from 'react-bootstrap';
import PanelRequest from '../forms/panelRequest/PanelRequestContainer';

function AddPanelRequest(props) {
    return (
       <div>
			<Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
				<Modal.Header closeButton>
					<Modal.Title>
						<h5 className="text-grey">Send Panel Request</h5>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<PanelRequest {...props} />
				</Modal.Body>
			</Modal>
		</div>
    );
}

export default AddPanelRequest;